import { axios } from '@/utils/request'

const api = {
  management: '/order/customerModel/add'
}

const api1 = {
  management: '/basicdata/QrCode/save'
}

const api2 = {
  management: '/dfs/QrCode/insert'
}

const api3= {
  management: '/order/customerModel/selectModel'
}

const api4= {
  management: '/order/customerModel/delete'
}

const api5= {
  management: '/order/customerModel/selectSubjectByModelId'
}

const api6= {
  management: '/order/customerModel/update'
}

const api7= {
  management: '/basicdata/QrCode/selectClientOrderInfo'
}
export function updataModel (parameter) {
  return axios({
    url: api6.management,
    method: 'post',
    data: parameter
  })
}
export function selectSubjectByModelId (parameter) {
  return axios({
    url: api5.management,
    method: 'get',
    params: parameter
  })
}

export function customerModelDelete (parameter) {
  return axios({
    url: api4.management,
    method: 'get',
    params: parameter
  })
}
export function customerModelList (parameter) {
  return axios({
    url: api3.management,
    method: 'get',
    params: parameter
  })
}

export function customerModelAdd (parameter) {
  return axios({
    url: api.management,
    method: 'post',
    data: parameter
  })
}

export function customerModelSave (parameter) {
  return axios({
    url: api1.management,
    method: 'post',
    data: parameter
  })
}

export function customerModelInsert (parameter) {
  return axios({
    url: api2.management,
    method: 'post',
    data: parameter
  })
}

export function selectClientOrderInfo (parameter) {
  return axios({
    url: api7.management,
    method: 'get',
    params: parameter
  })
}

export const enterpriseBlackListExport = api.enterpriseBlackList + '/export'